<template>
  <md-menu
    md-align-trigger
    md-direction="bottom-end"
  >
    <md-button
      md-menu-trigger
      :disabled="disabled"
      class="md-icon-button"
    >
      <slot name="button"></slot>
    </md-button>

    <md-menu-content>
      <slot name="items"></slot>
    </md-menu-content>
  </md-menu>
</template>

<script>
  export default {
    name: 'x-menu',

    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>


<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  /deep/ .md-list-item-content {
    min-height: auto;
    padding-top: $space-small;
    padding-bottom: $space-small;
    font-family: "Source Sans Pro";
  }
</style>
